module.exports = __webpack_public_path__ + "img/Multi asset.98ba600.png";